module.exports = __webpack_public_path__ + "app/img/eturtle_air_gonfle2.164445b1.jpg";